import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { OrdersComponent } from './orders.component';
import { OrdersRoutingModule } from './order-routing.module';

import { OrdersState } from '../core/store/order/orders.state';
import { OrderState } from '../core/store/order/order.state';
import { SharedModule } from '../shared/shared.module';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { CardModule } from 'primeng/card';
import { TimelineModule } from 'primeng/timeline';
import { DirectivesModule } from '../core/directives/directives.module';

@NgModule({
  declarations: [OrdersComponent, OrderDetailsComponent],
  imports: [
    OrdersRoutingModule,
    CommonModule,
    SharedModule,
    TableModule,
    TagModule,
    TooltipModule,
    ButtonModule,
    CardModule,
    TimelineModule,
    DirectivesModule,
  ],
})
export class OrdersModule {}
